// In-sequence nets report each saved pick separately (issue #2463): `index` is null when the
// saved row/column no longer exists before this step (an earlier delete/filter removed it, or
// new data renamed it). The server then sends an empty `by`, so fall back to these per-pick
// entries and keep the name of a missing pick to show it in the dialog.
export type RecipeSource = { index: number | null; name: string }

export type SavedPicks = {
  control?: number
  comparator?: number
  missingControl?: string
  missingComparator?: string
}

export const getSavedPicks = (iv: any): SavedPicks => {
  const sources: RecipeSource[] = iv.recipeSources || iv.recipe_sources || []
  const control = iv.control ?? iv.by?.[0] ?? sources[0]?.index ?? undefined
  const comparator = iv.comparator ?? iv.by?.[1] ?? sources[1]?.index ?? undefined
  return {
    control,
    comparator,
    missingControl: control == null ? sources[0]?.name : undefined,
    missingComparator: comparator == null ? sources[1]?.name : undefined
  }
}

// Flag the field red with the old pick's name while it is missing and still unreplaced.
export const missingPickProps = (
  missingName: string | undefined,
  value: number | undefined,
  label: string
): { validateStatus?: 'error'; help?: string } =>
  missingName && value == null
    ? {
        validateStatus: 'error',
        help: `"${missingName}" is no longer in the table. Pick a new ${label}.`
      }
    : {}

export const missingPlaceholder = (
  missingName: string | undefined,
  value: number | undefined,
  label: string
) => (missingName && value == null ? missingName : `Select ${label}`)
